import Swiper from "swiper";
import { Navigation, Pagination, A11y, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

const initQuotesSlider = () => {
  const partners = document.querySelectorAll(".quotes-slider-swiper");

  partners.forEach((partner) => {
    new Swiper(partner, {
      modules: [Navigation, Pagination, A11y, Autoplay],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      a11y: {
        enabled: true,
        scrollOnFocus: false,
      },
      autoplay: {
        delay: 3500, // 3.5 seconds per slide
        disableOnInteraction: false, // Keeps autoplay running after user swipes
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
};

window.addEventListener("load", () => {
  initQuotesSlider();
});
